import React from 'react';
import styles from './style.css';
import { CardImg, Card, CardTitle, CardText, CardBody, Col, Row, Button } from "reactstrap";
import classnames from 'classnames';

export class ProductSKUCard extends React.Component {

    constructor(props) {
        super(props);
    };

    setEllipsis(text){
        let phrase = '';
        const words = text.split(' ');
        for (let q = 0; q < words.length; q++) {
            const word = words[q];
            if(phrase.length + word.length > (30 + q)){
                phrase += ' ...';
                break;
            }
            phrase += ' ' + word;
        }
        return phrase;
    }

    render() {

        let product = this.props.product;
        const prodImg = product.productImage ? product.productImage : product.palettes[0] ? product.palettes[0].paletteImage : '';

        return (
            <Card key={product.productId}
                className={classnames(product.productId, styles.wrapCard, product.active ? styles.active : '')}
                onClick={this.props.onClick}>
                <div className={styles.img}>
                    <CardImg src={prodImg + (prodImg.indexOf('?') >= 0 ? '&w=200' : '?w=200')} />
                </div>
                <div className={styles.desc}>
                    <CardTitle className={styles.title}>{product.productBrand}</CardTitle>
                    <CardText className={styles.text} >
                        {this.setEllipsis(product.productName)}
                    </CardText>
                </div>
            </Card>
        );
    };
};